import { ethers } from "ethers";
// import { simpleRpcProvider } from './providers';
import { useBalance, useAccount, useNetwork } from "wagmi";
// @ts-ignore
import abi from "../constants/abi";
// @ts-ignore
import contracts from "../constants/contracts";

import MultiCallAbi from "../constants/Iabi/Multicall.json";

const RPC_URL = "https://rpc.buildbear.io/many-ric-olie-77c2a995";
// Addresses
const simpleRpcProvider = new ethers.providers.JsonRpcProvider(RPC_URL);
const MultiCallAddress = "0x75095fe8bb4a7ddE280942d61E1Dc912288d67F0"; //this is for private buildbear
//const MultiCallAddress = "0x75095fe8bb4a7dde280942d61e1dc912288d67f0"; this is for goerli testnet
const getContract = (
  abi: any,
  address: string,
  signer?: ethers.Signer | ethers.providers.Provider
) => {
  const signerOrProvider = signer ?? simpleRpcProvider;
  return new ethers.Contract(address, abi, signerOrProvider);
};

export const getMulticallContract = (
  signer?: ethers.Signer | ethers.providers.Provider
) => {
  return getContract(MultiCallAbi, MultiCallAddress, signer);
};
export const getMarketplaceContract = (
  signer?: ethers.Signer | ethers.providers.Provider
) => {
  return getContract(abi.MARKETPLACE, contracts.MARKETPLACE, signer);
};

export const getAuctionContract = (
  signer?: ethers.Signer | ethers.providers.Provider
) => {
  return getContract(abi.AUCTION, contracts.AUCTION, signer);
};
